import React from 'react';
import { htmlToText } from '~/helpers/data';
import RawHTML from '~/components/jsx-helpers/raw-html';
import AccordionGroup from '~/components/accordion-group/accordion-group';
import './FAQBlock.scss';
export function FAQBlock({ data }) {
    const accordionItems = React.useMemo(() => data.value.map((d) => ({
        title: htmlToText(d.value.question),
        contentComponent: React.createElement(RawHTML, { html: d.value.answer })
    })), [data]);
    return React.createElement("div", { className: "content-block-faq" },
        React.createElement("div", { className: "articles" },
            React.createElement(AccordionGroup, { items: accordionItems, noScroll: true, forwardOnChange: false })));
}
